import { render, staticRenderFns } from "./CrmNueva.vue?vue&type=template&id=27757ad5"
import script from "./CrmNueva.vue?vue&type=script&lang=js"
export * from "./CrmNueva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports